import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import {
  IUserSubscription,
  IUserSubscriptionCancellationReason,
  IUserSubscriptionCreditLog,
} from "../../models/UserSubscription";
import { UserSubscriptionService } from "../../services/user-subscription.service";
import { IPaginationParams } from "../types";

export const useGetUserSubscriptionsByUserIdQuery = (
  userId: string,
  pagination: IPaginationParams
) => {
  return useQuery<{ items: IUserSubscription[]; total: number }, Error>({
    queryKey: [QUERY_CONSTANTS.GET_USER_SUBSCRIPTIONS_BY_USER, userId, pagination],
    queryFn: () => UserSubscriptionService.getByUserId(userId, pagination).then((res) => res.data),
  });
};

export const useGetUserSubscriptionCancellationReasonQuery = (userSubscriptionId: string) => {
  return useQuery<IUserSubscriptionCancellationReason | null, Error>({
    queryKey: [QUERY_CONSTANTS.GET_USER_SUBSCRIPTION_CANCELLATION_REASON, userSubscriptionId],
    queryFn: () =>
      UserSubscriptionService.getCancellationReason(userSubscriptionId).then((res) => res.data),
  });
};

export const useGetUserSubscriptionsCreditLogsQuery = (
  userSubscriptionId: string,
  pagination: IPaginationParams
) => {
  return useQuery<{ items: IUserSubscriptionCreditLog[]; total: number }, Error>({
    queryKey: [QUERY_CONSTANTS.GET_USER_SUBSCRIPTION_USER_LOGS, userSubscriptionId, pagination],
    queryFn: () =>
      UserSubscriptionService.getLogs(userSubscriptionId, pagination).then((res) => res.data),
  });
};
